<app-header></app-header>
<div class="page-content">
  <div class='card text-center'>
    <!-- Mensaje de carga -->
    <div *ngIf='loading'>
      <h4 class='mb-3'>
        Descargando tu {{ isPdf ? 'comprobante en PDF' : 'paquete de documentos ZIP' }}...
      </h4>
      <p>Por favor espera unos segundos.</p>
  
      <div class='progress'>
        {{ progress }}%
      </div>

    <mat-progress-bar 
        *ngIf="loading" 
        mode="determinate" 
        [value]="progress">
    </mat-progress-bar>

    </div>
  
    <!-- Mensaje de éxito -->
    <div *ngIf='success && !loading'>
      <h3 class='mb-2'>✅ {{ isPdf ? 'PDF descargado correctamente' : 'ZIP descargado correctamente' }}</h3>
      <p>
        {{ isPdf
          ? 'Tu comprobante de seguro se ha descargado exitosamente.'
          : 'Tu archivo ZIP con todos los documentos ha sido descargado.' }}
      </p>
      <p class='text-muted'>Serás redirigido automáticamente en {{ countdown }} segundos.</p>

      <button mat-button type="submit" (click)="downloadAgain()" class="button button-fill color-dark button-round" [disabled]="loading">
        <span *ngIf="!loading && downloadCounter ==0">{{'BUTTONS.DOWNLOAD' | translate}}</span>
        <span *ngIf="!loading && downloadCounter>=1">{{'BUTTONS.DOWNLOAD_AGAIN' | translate}}</span>        
      </button>
    </div>
  
    <!-- Mensaje de error -->
    <div *ngIf='error && !loading'>
      <h4>❌ Hubo un error</h4>
      <p>No se pudo descargar el {{ isPdf ? 'PDF' : 'archivo ZIP' }}. Intenta más tarde.</p>
      <button class='btn btn-outline-danger mt-3' (click)='goBack()'>Volver</button>
    </div>
  </div>
</div>

<app-simple-footer></app-simple-footer>